module.exports = __webpack_public_path__ + "media/images/del-icon-e8de4d0116b690d84092f885405509ab.svg";